// Create this file at: frontend/src/contexts/UnsavedChangesContext.js

import React, { createContext, useState, useContext } from 'react';

// 1. Create the context with a default shape
const UnsavedChangesContext = createContext({
    isDirty: false,
    setIsDirty: () => {},
});

// 2. Create a custom hook for easy consumption
export const useUnsavedChanges = () => useContext(UnsavedChangesContext);

// 3. Create the Provider component that will manage the state
export const UnsavedChangesProvider = ({ children }) => {
    const [isDirty, setIsDirty] = useState(false);

    const value = { isDirty, setIsDirty };

    return (
        <UnsavedChangesContext.Provider value={value}>
            {children}
        </UnsavedChangesContext.Provider>
    );
};